const initialState = {
  history: [],
  patterns: [],
  filters: {},
  selectedFile: {},
  details: {
    results: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_RTS_FILE_HISTORY':
      return {
        ...state,
        history: action.history,
      };
    case 'SET_RTS_PATTERNS':
      return {
        ...state,
        patterns: action.patterns,
      };
    case 'SET_RTS_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case 'SET_RTS_FIELD':
      return {
        ...state,
        ...action.payload,
      };
    case 'CLEAR_RTS_DETAILS_MODAL':
      return {
        ...state,
        details: initialState.details,
        selectedFile: initialState.selectedFile,
      };
    case 'CLEAR':
      return initialState;
    default:
      return state;
  }
};
